import React from 'react'
import classnames from 'classnames/bind'
import { getConfig } from '@caudena/core/useConfig'

import buildUrl from '@caudena/core/utils/buildUrl'
import Portlet from '@caudena/core/Portlet'
import useHttp from '@caudena/core/useHttp'
import { Typography } from '@caudena/core/ui-kit'
import { Stub } from '@caudena/core/ui-kit'

import SeverityDonut from '../../Chart/severityDonut'

import {
  TriggeredTransactionsAmountData,
  TriggeredTransactionsAmountApiParams,
} from '../../../types/Dashboard'

import styles from './index.scss'

const cx = classnames.bind(styles)

interface TriggeredTransactionsAmountBlockProps {
  className?: string
  assignee?: number
}

const TriggeredTransactionsAmountBlock: React.FC<
  TriggeredTransactionsAmountBlockProps
> = ({ className, assignee }) => {
  const apiParams = React.useMemo(
    (): TriggeredTransactionsAmountApiParams => ({
      assignee_id: assignee,
    }),
    [assignee]
  )

  const { data, isFirstLoading } = useHttp<TriggeredTransactionsAmountData>(
    buildUrl`${getConfig()?.COMPLIANCE_API}/api/dash/sum_by_risk?${apiParams}`
  )

  const donutData = React.useMemo(() => {
    const high = parseInt(data?.HIGH || '0')
    const medium = parseInt(data?.MEDIUM || '0')
    const low = parseInt(data?.LOW || '0')

    return {
      high,
      medium,
      low,
      total: high + medium + low,
    }
  }, [data])

  return (
    <Portlet variant="card" className={className}>
      {{
        title: (
          <Typography variant="heading3" color="grey1">
            Risk amount
          </Typography>
        ),
        body: isFirstLoading ? (
          <Stub
            className={cx('TriggeredTransactionsAmountPortletStub')}
            isActive={true}
          />
        ) : (
          <SeverityDonut data={donutData} />
        ),
      }}
    </Portlet>
  )
}

export default TriggeredTransactionsAmountBlock
